import { API_BASE_URL } from '../settings';
import { Account } from '../models/index';
import axios from 'axios';

export const getMyAccount = params => {
  return axios.get(API_BASE_URL + 'my-account')
    .then(res => res.data)
    .then(res => res.data);
}

export const createAccount = account => {
  return axios
    .post(API_BASE_URL + 'accounts', Account(account))
    .then(res => res.data)
    .then(res => res.data);
};

export const updateAccount = (accountId, account) => {
  return axios
    .put(API_BASE_URL + 'accounts/' + accountId, Account(account))
    .then(res => res.data)
    .then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/services/account.services.js